/**
 * Thẻ xem trước sản phẩm ở trang "Rải link lụm tiền" — ảnh, giá, HOA HỒNG, và các
 * dòng nhắc ưu đãi giống thẻ sản phẩm ở trang Mua sắm.
 *
 * Vì sao cần: trước đây rải link chỉ trả về một chuỗi link, user không biết sản
 * phẩm đó hoàn bao nhiêu — phải sang trang Mua sắm dán lại lần nữa mới xem được.
 *
 * `lockedForGuest`: sàn bắt buộc đăng nhập mới lấy được link (TikTok Shop — API
 * gắn userId từ session). Vẫn cho xem hoa hồng trước rồi mới mời đăng nhập.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import AppX2CashbackNote from "../../components/Ecommerce/AppX2CashbackNote";
import { getProductNote } from "../../api/productNotesApi";
import { PLATFORM_INFO } from "./detect-platform";

function formatMoney(amount) {
    return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
        maximumFractionDigits: 0,
    }).format(amount);
}

function LinkConverterProductPreview({ product, platform, lockedForGuest }) {
    const meta = PLATFORM_INFO[platform] ?? {};
    // Dòng nhắc do admin cấu hình cho sàn này (file tĩnh /img/product-notes.json).
    // Rỗng = không hiện gì; lỗi tải cũng chỉ là không hiện.
    const [productNote, setProductNote] = useState("");
    useEffect(() => {
        let mounted = true;
        getProductNote(platform).then((text) => mounted && setProductNote(text || ""));
        return () => {
            mounted = false;
        };
    }, [platform]);

    const image = product?.imageUrl || product?.productImage;
    const price = Number(product?.price ?? product?.priceMin) || 0;
    // null = chưa tra được hệ số, khác hẳn 0 = sàn thật sự không trả hoa hồng.
    const commission = product?.commission == null ? null : Number(product.commission);

    return (
        <div className="mt-4 p-4 bg-surface-sunken border border-line rounded-xl">
            <div className="flex gap-3">
                {image && (
                    <img
                        src={image}
                        alt=""
                        className="w-20 h-20 rounded-lg object-cover bg-surface shrink-0"
                    />
                )}
                <div className="min-w-0">
                    <p className="text-sm font-semibold line-clamp-2">
                        {product?.productName || meta.name}
                    </p>
                    {price > 0 && <p className="text-sm font-bold mt-0.5">{formatMoney(price)}</p>}

                    {commission === null ? (
                        <p className="text-xs text-content-3 mt-0.5">
                            Chưa tra được mức hoàn tiền — link vẫn ghi nhận bình thường
                        </p>
                    ) : commission > 0 ? (
                        <p className={`text-xs mt-0.5 ${meta.textColor ?? "text-brand-red"}`}>
                            Hoàn tiền đến{" "}
                            <span className="text-sm font-bold">{formatMoney(commission)}</span>
                        </p>
                    ) : (
                        <p className="text-xs text-content-3 mt-0.5">
                            Sản phẩm này hiện không được hoàn tiền
                        </p>
                    )}

                    {/* Dòng nhắc theo sàn (admin sửa) + thưởng thêm của sàn (BE đẩy) —
                        chỉ có nghĩa khi thật sự có hoàn tiền. */}
                    {!!commission && (
                        <>
                            {!!productNote && (
                                <p className="mt-1 rounded-lg bg-amber-50 px-2 py-1 text-xs font-semibold text-amber-700">
                                    {productNote}
                                </p>
                            )}
                            {!!product?.platformBonusNote && (
                                <p className="mt-1 rounded-lg bg-amber-50 px-2 py-1 text-xs font-semibold text-amber-700">
                                    {product.platformBonusNote}
                                </p>
                            )}
                            <AppX2CashbackNote />
                        </>
                    )}
                </div>
            </div>

            {lockedForGuest && (
                <>
                    <p className="text-xs text-content-3 mt-3">
                        Đăng nhập để lấy link đã gắn mã của bạn — mua qua link đó mới được ghi nhận
                        hoàn tiền.
                    </p>
                    {/* ?redirect= là cách trang Login nhận nơi quay về (xem Login.js) —
                        đăng nhập xong đưa thẳng lại đây thay vì đổ về trang chủ. */}
                    <Link
                        to="/login?redirect=link-converter"
                        className={`mt-3 w-full flex items-center justify-center gap-2 py-3 rounded-xl font-bold text-white text-sm active:scale-[0.98] transition-all ${
                            meta.buttonColor ?? "bg-brand-red hover:opacity-90"
                        }`}
                    >
                        <FontAwesomeIcon icon={faRightToBracket} />
                        Đăng nhập để lấy link hoàn tiền
                    </Link>
                </>
            )}
        </div>
    );
}

export default LinkConverterProductPreview;
